import React, { useState } from 'react';
import ResumeList from '../ResumeBuilder/ResumeList';
import AdminResumeBuilder from './AdminResumeBuilder';
import axios from 'axios';

const API_BASE_URL = 'https://www.testometer.in:8084/api';

const AdminResumeManagement = () => {
  const [showBuilder, setShowBuilder] = useState(false);
  const [selectedResume, setSelectedResume] = useState(null);

  const handleCreateResume = () => {
    setSelectedResume(null);
    setShowBuilder(true);
  };

  const handleEditResume = async (resume) => {
    try {
      // Fetch the full resume with all details
      const response = await axios.get(`${API_BASE_URL}/resumes/${resume.id}`);
      setSelectedResume(response.data);
      setShowBuilder(true);
    } catch (error) {
      alert('Failed to load resume details.');
    }
  };

  const handleBackToList = () => {
    setShowBuilder(false);
    setSelectedResume(null);
  };

  if (showBuilder) {
    return (
      <div className="admin-resume-management">
        <AdminResumeBuilder 
          resumeToEdit={selectedResume}
          onSave={handleBackToList}
          onBackToList={handleBackToList}
        />
      </div>
    );
  }

  return (
    <>
    <br/>
    <div className="admin-resume-management">
      {/* <div className="management-header">
        <div>
          <h2>Resume Management</h2>
          <p>Manage and monitor all resumes in the system</p>
        </div>
      </div> */}
      
      <ResumeList 
        onCreateResume={handleCreateResume}
        onEditResume={handleEditResume}
      />
    </div>
    </>
  );
};

export default AdminResumeManagement; 